import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {html, type TemplateResult} from "lit";
import {GLOBAL} from "../../../common/globals";
import {autoRegister, resolve} from "../../../container";
import {Dictionary} from "../dictionary";
import type {Nullable} from "../../../bootstrap/common/types";
import {trackingTextlinkInteract} from "../../../tracking/trackingAttributes";
import {EopErrorHandler} from "../../../common/errorHandler";

export interface Share {
    isSupported: () => boolean;
    share: (data: ShareData) => Promise<void>;
}

@autoRegister()
export class NavigatorShare implements Share {
    public isSupported(): boolean {
        return GLOBAL.navigator().share !== undefined;
    }

    public share(data: ShareData): Promise<void> {
        return GLOBAL.navigator().share(data);
    }
}

@customElement("eop-share-link")
export class EopShareLink extends UnLitElement {

    @property({attribute: "description"})
    private description: string;

    private dictionary: Dictionary;

    public constructor(
        private navigatorShare: Share = resolve(NavigatorShare),
        private errorHandler: EopErrorHandler = resolve(EopErrorHandler)
    ) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.dictionary = Dictionary.of(this);
    }

    public render(): Nullable<TemplateResult> {
        if (!this.navigatorShare.isSupported()) {
            return null;
        }
        return html`
            <button class="link share-link" @click=${this.shareLink} ${trackingTextlinkInteract("share-page")}
            >${this.dictionary.translate("MSG_SHARE_BUTTON")}</button>
        `;
    }

    private shareLink(_ev: Event): void {
        this.navigatorShare.share({
            title: document.title,
            text: this.description,
            url: new URL(GLOBAL.window().location.href).toString()
        }).catch(e => {
            if (e.toString().includes("AbortError")) {
                // noop. Can happen if user cancels the share dialog and should not lead to crash
            } else {
                this.errorHandler.report("Error link-sharing", e);
            }
        });
    }
}